import { render, staticRenderFns } from "./BulkForm.vue?vue&type=template&id=0b057f4e&scoped=true"
import script from "./BulkForm.vue?vue&type=script&lang=js"
export * from "./BulkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b057f4e",
  null
  
)

export default component.exports